<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <div v-else>
      <v-card class="card-body">
        <v-container>
          <h5>Neuer Kontakt</h5>
          <hr>

          <!-- Import Active Directory User -->
          <b-row>
            <v-autocomplete
              v-model="activedirectoryUser"
              :filter="filterActivedirectoryUsers"
              :items="activedirectoryUsers"
              class="mb-4"
              clearable
              placeholder="aus Active Directory auswählen..."
              return-object
              @change="addUserFromActivedirectory"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <div>
                  {{ getActivedirectoryUserDisplayString(data.item) }}
                </div>
              </template>

              <template
                slot="item"
                slot-scope="data"
              >
                <div>
                  {{ getActivedirectoryUserDisplayString(data.item) }}
                </div>
              </template>
            </v-autocomplete>
          </b-row>

          <!-- Organisation-->
          <b-row class="mt-5">
            <label class="mt-4 col-3 defaultLabel"> Organisation </label>
            <div class="col-7 pl-1">
              <v-autocomplete
                v-model="contactObject.organisationId"
                :items="organisation_items"
                clearable
                item-text="name"
                item-value="id"
                label="Organisation"
                no-data-text="Es wurden keine Einträge gefunden"
                placeholder="Nach Organisationen suchen..."
              />
            </div>
          </b-row>

          <!-- Anrede-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Anrede </label>
            <div class="col-7 pl-1">
              <v-autocomplete
                v-model="contactObject.formOfAddressId"
                :items="anreden_items"
                clearable
                item-text="value"
                item-value="formOfAddressId"
                label="Anrede"
                no-data-text="Es wurden keine Einträge gefunden"
                placeholder="Nach Anreden suchen..."
              />
            </div>
            <div
              v-if="$IsUserInRole('KonfigurationContentmanager')"
              class="col-2"
            >
              <v-btn
                color="success"
                dark
                fab
                small
                title="Neue Anrede Erfassen"
                @click="createAnreden"
              >
                <i class="fas fa-plus" />
              </v-btn>
            </div>
          </b-row>

          <!-- Nachname-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Nachname </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="contactObject.lastName"
                label="Nachname"
              />
            </div>
          </b-row>

          <!-- Vorname-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Vorname </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="contactObject.firstName"
                label="Vorname"
              />
            </div>
          </b-row>

          <!-- Email-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Email </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="contactObject.email"
                label="Email"
              />
            </div>
          </b-row>

          <!-- Telefon-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Telefon </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="contactObject.phone"
                label="Telefon"
              />
            </div>
          </b-row>

          <!-- Mobile-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel"> Mobile </label>
            <div class="col-7 pl-1">
              <v-text-field
                v-model="contactObject.mobilePhone"
                label="Mobile"
              />
            </div>
          </b-row>

          <!-- Kommunikationssprache-->
          <b-row class="mt-2">
            <label class="mt-4 col-3 defaultLabel">
              Kommunikationssprache
            </label>
            <div class="col-7 pl-1">
              <v-autocomplete
                v-model="contactObject.communicationLanguageId"
                :items="communicationLanguage_items"
                clearable
                item-text="name"
                item-value="id"
                label="Kommunikationssprache"
                no-data-text="Es wurden keine Einträge gefunden"
              />
            </div>
          </b-row>

          <b-row
            v-if="
              !contactObject.formOfAddressId ||
                !contactObject.lastName ||
                !contactObject.communicationLanguageId
            "
            class="mt-4"
          >
            <div class="col-3" />
            <div class="col-7 pl-1">
              <v-alert
                v-model="alert"
                dismissible
                outline
                type="warning"
              >
                Pflichtfelder: Anrede,Nachname und Kommunikationssprache
              </v-alert>
            </div>
          </b-row>
        </v-container>
      </v-card>

      <v-btn
        :disabled="
          !contactObject.formOfAddressId ||
            !contactObject.lastName ||
            !contactObject.communicationLanguageId
        "
        class="btn-left"
        color="success"
        raised
        title="Kontakt Erfassen"
        @click="createNew"
      >
        <i class="fas fa-plus mr-3" /> Neu Erfassen
      </v-btn>

      <v-btn
        color="#e72b37"
        raised
        style="color: white"
        title="Erfassen Abbrechen"
        @click="cancelCreate"
      >
        <i class="fas fa-ban mr-3" /> Abbrechen
      </v-btn>
    </div>
  </div>
</template>

<script>
import {
  GetFormOfAddress,
  GetOragnisations,
  PostContacts,
} from "@/services/user.crm.service";
import { GetActivedirectoryUsers } from "@/services/user.service.js";
import { GetFallbackLanguages } from "@/services/contract.edition.translation.service";

export default {
  data() {
    return {
      isLoading: false,
      alert: true,
      contactObject: {
        id: 0,
        identityUserId: "",
        lastName: "",
        firstName: "",
        organisationId: null,
        formOfAddressId: null,
        communicationLanguageId: null,
        email: "",
        phone: "",
        mobilePhone: "",
      },
      anreden_items: [],
      organisation_items: [],
      communicationLanguage_items: [],
      activedirectoryUsers: [],
      activedirectoryUser: {},
      errorObject: null,
    };
  },
  created() {
    this.getFormOfAddress();
    this.LoadActivedirectoryUsers();
  },
  methods: {
    createAnreden() {
      localStorage.contactObject = JSON.stringify(this.contactObject);
      this.$router.push({
        path: "/anrede/create?createContact=true",
      });
    },
    resetLocalStorageContactObject() {
      localStorage.removeItem("contactObject");
    },
    addUserFromActivedirectory() {
      if (this.activedirectoryUser) {
        this.contactObject.email = this.activedirectoryUser.email;
        this.contactObject.firstName = this.activedirectoryUser.firstName;
        this.contactObject.lastName = this.activedirectoryUser.lastName
          ? this.activedirectoryUser.lastName
          : this.activedirectoryUser.userName;
        this.contactObject.phone = this.activedirectoryUser.phoneNumber;
        this.contactObject.mobilePhone = this.activedirectoryUser.mobilePhone;

        this.contactObject.communicationLanguageId =
          this.communicationLanguage_items.find(
            (x) => x.isoCode === this.activedirectoryUser.language,
          ).id;
      }
    },
    getActivedirectoryUserDisplayString(item) {
      if (item.userName) {
        return item.userName;
      }
      if (item.lastName && item.firstName) {
        return item.lastName + " " + item.firstName;
      }
      if (item.lastName) {
        return item.lastName;
      }
      return "";
    },
    cancelCreate() {
      this.resetLocalStorageContactObject();

      this.$router.push({
        path: "/contacts",
      });
    },
    createNew() {
      this.isLoading = true;

      PostContacts(
        this.contactObject,
        () => {
          this.isLoading = false;
          this.resetLocalStorageContactObject();

          this.$router.push({
            path: `/contacts`,
            quey: { source: this.$route.path },
          });
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    getFormOfAddress() {
      this.isLoading = true;
      this.errorObject = null;

      GetFormOfAddress(
        (response) => {
          this.anreden_items = response;
          this.getOrganisations();
        },

        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getOrganisations() {
      this.isLoading = true;
      GetOragnisations(
        1,
        1,
        "",
        "",
        0,
        (response) => {
          //Zuerst nur eine Organisation abrufen um die Anzahl Organisationen zu bekommen
          GetOragnisations(
            response.numberOfItems,
            1,
            "",
            "",
            0,
            (response2) => {
              this.organisation_items = response2.organisations;
              this.getSupportedLanguages();
            },
            (error) => {
              this.errorObject = error;
              this.isLoading = false;
            },
          );
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getSupportedLanguages() {
      GetFallbackLanguages(
        (response) => {
          if (
            localStorage.getItem("contactObject") &&
            !JSON.parse(localStorage.getItem("contactObject")).id
          ) {
            this.contactObject = JSON.parse(
              localStorage.getItem("contactObject"),
            );
          }
          this.communicationLanguage_items = response;
          this.isLoading = false;
        },

        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    LoadActivedirectoryUsers() {
      this.errorObject = null;

      GetActivedirectoryUsers(
        (response) => {
          this.activedirectoryUsers = response;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    filterActivedirectoryUsers(option, search) {
      if (option.userName) {
        return option.userName.toLowerCase().indexOf(search.toLowerCase()) > -1;
      }
      if (option.lastName) {
        return option.lastName.toLowerCase().indexOf(search.toLowerCase()) > -1;
      }
      if (option.firstName) {
        return (
          option.firstName.toLowerCase().indexOf(search.toLowerCase()) > -1
        );
      }
      if (option.email) {
        return option.email.toLowerCase().indexOf(search.toLowerCase()) > -1;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.card-body {
  margin: 20px;
}

.btn-left {
  margin-left: 20px;
}
</style>
